export const FONCTIONS_STAFF = [
    'entraîneur principal',
    'entraîneur adjoint',
    'intendant principal',
    'intendant adjoint',
    'soigneur',
    'arbitre accompagnateur',
]


// WEBPACK FOOTER //
// ./src/data/fonctions_staff.js